import { computed, Injectable, signal } from "@angular/core";
import { StockDetailStateModel } from "../Dto/StockDetailStateModel";
import { PaginationInfo } from "../Dto/StockSearchResponse";
import { Stock } from "../Dto/StockModel";
import { StockMovement } from "../Dto/StockMovementModel";

const initialPagination: PaginationInfo = {
  page: 1,
  limit: 20,
  total: 0,
  pages: 0,
};

const initialState: StockDetailStateModel = {
  stock: null,
  movements: [],
  pagination: initialPagination,
  loadingStock: false,
  loadingMovements: false,
  stockError: null,
  movementError: null,
};

@Injectable()
export class StockDetailState {
  private readonly state = signal<StockDetailStateModel>(initialState);

  readonly stock = computed(() => this.state().stock);
  readonly movements = computed(() => this.state().movements);
  readonly pagination = computed(() => this.state().pagination);
  readonly loadingStock = computed(() => this.state().loadingStock);
  readonly loadingMovements = computed(() => this.state().loadingMovements);
  readonly stockError = computed(() => this.state().stockError);
  readonly movementError = computed(() => this.state().movementError);

  setStock(stock: Stock | null): void {
    this.state.update((state) => ({ ...state, stock, loadingStock: false, stockError: null }));
  }

  setStockLoading(loadingStock: boolean): void {
    this.state.update((state) => ({ ...state, loadingStock }));
  }

  setStockError(stockError: string | null): void {
    this.state.update((state) => ({ ...state, stockError, loadingStock: false }));
  }

  setMovements(movements: StockMovement[], pagination: PaginationInfo): void {
    this.state.update((state) => ({
      ...state,
      movements,
      pagination,
      loadingMovements: false,
      movementError: null,
    }));
  }

  setMovementLoading(loadingMovements: boolean): void {
    this.state.update((state) => ({ ...state, loadingMovements }));
  }

  setMovementError(movementError: string | null): void {
    this.state.update((state) => ({ ...state, movementError, loadingMovements: false }));
  }

  reset(): void {
    this.state.set(initialState);
  }
}
